module.exports = __webpack_public_path__ + "img/pxIcon.6552a304.png";